import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import ReactGA4 from 'react-ga4';

import { connect } from 'react-redux';
import config from '../../../../config.js';

function AppAnalytics({ }) {
    useEffect(() => {
        // if(typeof window !== 'undefined' /* && process.env.NODE_ENV === 'production'*/) {
        //     window.addEventListener('load', () => {
        //         console.log('Window::: Loaded');
        // store.dispatch(setAppLoaded())

        // GA: New
        if(config.google?.analytics?.trackingCodeGA4) {
            ReactGA4.gtag('consent', 'default', {
                ad_storage: 'denied',
                ad_user_data: 'denied',
                ad_personalization: 'denied',
                analytics_storage: 'granted',
            });
            config.google.analytics.trackingCodeGA4.split(',').forEach(trackingId => {
                ReactGA4.initialize(trackingId, {
                    // gtagOptions: {
                    //     server_container_url: '',
                    // },
                });
            });
            ReactGA4.ga('set', 'appName', config.application.name);
            ReactGA4.ga('set', 'appVersion', config.version);
            ReactGA4.gtag('consent', 'update', {
                analytics_storage: 'granted',
            });
            config.google.gtag?.id && ReactGA4.gtag('config', config.google.gtag.id, { allow_enhanced_conversions: true, send_page_view: false });
        }

        // config.bugsnag.key && BugsnagPerformance.start({
        // 	apiKey: config.bugsnag.key,
        // 	appVersion: config.version || '0.0.1',
        // 	releaseStage: process.env.NODE_ENV,
        // 	settleIgnoreUrls: [/.*\/console\//]
        // })
        //     });
        // }
    }, []);
    return null;
}

function mapStateToProps(store, props) {
    return {
    };
}

AppAnalytics.propTypes = {
};

export default connect(mapStateToProps)(AppAnalytics);
